import React, {Component} from "react";
import {UnSortableTableHeader} from "../../components/table/unsortable-table-header";

export default class EnvironmentCommentaryTableHeader extends Component
{
  static Layout = [
    
      { column: "fldPeriod", width: 3, name: "Period" },
      { column: "fldYear", width: 3, name: "Year" },
      { column: "utility", width:3, name: "Utility"},
      { column: "comment" ,width:9, name: "Comment" },
    
  ];
 render() {
      return (
          <UnSortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={EnvironmentCommentaryTableHeader.Layout}/>
          
      )
  }
}